
const Table = () => import('@/../../coreui/components/ServerTable')
const CrmContacts = () => import('@/components/CRM/Contacts')
const WorkFlow = () => import('@/components/CRM/WorkFlow')
const SalesPipeline = () => import('@/components/CRM/SalesPipeline')
const CampaignCreate = () => import('@/components/CRM/CampaignCreate')


export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null || allowed.includes('CRM'))  {
    routes =  [
      {
        path: '/CrmProspect',
        name: 'CrmProspect',
        component: Table,
        props: {
          schema: 'sch_crm_prospect', 
          table: 'crm_prospect'
        } 
      },
      {
        path: '/CrmLink',
        name: 'CrmLink',
        component: Table,
        props: {
          schema: 'sch_crm_link',
          table: 'crm_link'
        }
      },
      {
        path: '/CrmDownloadRequests',
        name: 'CrmDownloadRequests',
        component: Table,
        props: {
          schema: 'sch_crm_downloads',
          table: 'crm_downloads'
        }
      },
      {
        path: '/CrmMessages',
        name: 'CrmMessages',
        component: Table,
        props: {
          schema: 'sch_crm_contact_request',
          table: 'crm_contact_request'
        }
      },
      /*
      {
        path: '/CrmCompany',
        name: 'CrmCompany',
        component: Table,
        props: {
          schema: 'sch_crm_company', 
          table: 'crm_company'
        } 
      },
      {
        path: '/CrmContacts',
        name: 'CrmContacts',
        component: CrmContacts
      },
      {
        path: '/CrmSales',
        name: 'CrmSales',
        component: Table,
        props: {
          schema: 'sch_crm_sales', 
          table: 'crm_sales'
        } 
      },
      ,
      */
      {
        path: '/CrmTemplate',
        name: 'CrmTemplate',
        component: Table,
        props: {
          schema: 'sch_crm_template',
          table: 'crm_template'
        }
      },
      {
        path: '/CrmCampaign',
        name: 'CrmCampaign',
        component: Table,
        props: {
          schema: 'sch_crm_campaign',
          table: 'crm_campaign'
        }
      },
      {
        path: '/CrmUnsub',
        name: 'CrmUnsub',
        component: Table,
        props: {
          schema: 'sch_crm_unsub',
          table: 'crm_unsub',
          editable: false
        }
      },
      {
        path: '/CrmWorkflow',
        name: 'Workflow',
        component: WorkFlow,
        props: {
          module: 'CRM'
        }
      },
      {
        path: '/CrmCampaignCreate',
        name: 'CampaignCreate',
        component: CampaignCreate
      },
      {
        path: '/CrmToDo',
        name: 'CrmToDo',
        component: Table,
        props: {
          schema: 'sch_dev_todo', 
          table: 'dev_todo'
        } 
      },
      {
        path: '/CrmSalesPipeline',
        name: 'CrmSalesPipeline',
        component: SalesPipeline
      },
      {
        path: '/CrmPartners',
        name: 'CrmPartners',
        component: Table,
        props: {
          schema: 'sch_crm_partners', 
          table: 'crm_partners'
        } 
      },
      {
        path: '/CrmReleaseNotes',
        name: 'CrmReleaseNotes',
        component: Table,
        props: {
          schema: "sch_crm_release_notes",
          table: "crm_release_notes"
        }
      }
    ] 
  } 
  return routes
}
